"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var didi = _interopRequireWildcard(require("@/api/didi/didi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      dialogVisible: false,
      direction: 'rtl',
      map: null,
      loading: false,
      zjVisible: false,
      drivingOptions: [{
        type: 0,
        title: '圆形'
      }, {
        type: 1,
        title: '多边形'
      }
      /*        { type: 2, title: '行政区域' },*/],
      timeList: [{
        startTime: null,
        endTime: null,
        startingPrice: null
      }],
      routeList: null,
      polygon: null,
      polyEditor: null,
      circle: null,
      circleEditor: null,
      areaPolygon: null,
      areaBounds: null,
      serviceData: [],
      placeSearch: null,
      auto: null,
      mapType: 1,
      radius: 1000,
      formData: {
        serviceTypeDesc: null,
        overMileage: 50,
        overKilometer: 1,
        waitingFees: '1元/1分钟',
        merId: null,
        name: null,
        serviceType: null,
        isVirtual: null,
        timeList: null,
        polygonData: null
      },
      polygonData: []
    };
  },
  mounted: function mounted() {},
  methods: {
    showContent: function showContent(data) {
      this.dialogVisible = true;
      this.zjVisible = true;
      this.formData = data;
      this.formData.timeList = data.polygonRules;
      this.timeList = data.polygonRules;
      this.polygonData = data.polygonData;
      this.loadAMap();
    },
    handleClose: function handleClose() {
      this.$refs['formData'].resetFields();
      this.timeList = [{
        startTime: null,
        endTime: null,
        startingPrice: null
      }];
      this.formData.serviceType = null;
      this.formData.merId = null;
      this.dialogVisible = false;
    },
    loadAMap: function loadAMap() {
      var _this = this;
      window.AMapLoader.load({
        key: '3072a11ee675b099a1f5a96c8418978f',
        version: '2.0',
        plugins: ['AMap.Scale', 'AMap.Driving', 'AMap.PlaceSearch', 'AMap.AutoComplete', 'AMap.PolygonEditor', 'AMap.CircleEditor']
        // 省略了Loca和AMapUI的加载代码，因为它在Vue 2示例中可能用不到或需要另外处理
      }).then(function (AMap) {
        console.log(AMap);
        _this.map = new AMap.Map('container', {
          resizeEnable: true,
          center: [120.16, 35.94],
          zoom: 13
        });
        _this.map.addControl(new AMap.Scale());
        _this.setPolygon();
        //关键字查询
        _this.searchMap();
      }).catch(function (e) {
        console.error(e);
      });
    },
    setPolygon: function setPolygon() {
      var polygonPath = [];
      this.polygonData.forEach(function (item) {
        polygonPath.push(new window.AMap.LngLat(item[0], item[1]));
      });
      this.polygon = new window.AMap.Polygon({
        path: polygonPath,
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        fillColor: '#1791fc',
        zIndex: 50,
        bubble: true
      });
      this.map.add(this.polygon);
      console.log(this.map);
      this.polyEditor = new window.AMap.PolygonEditor(this.map, this.polygon);
      this.polyEditor.open();
    },
    // 关键字查询
    searchMap: function searchMap() {
      // 搜索框自动完成类
      this.auto = new AMap.AutoComplete({
        input: 'pointStart' // 使用联想输入的input的id
      });
      //构造地点查询类
      this.placeSearch = new AMap.PlaceSearch({
        map: this.map
      });
      // 当选中某条搜索记录时触发
      this.auto.on('select', this.selectSite);
    },
    //选中查询出的记录
    selectSite: function selectSite(e) {
      if (e.poi.location) {
        this.placeSearch.setCity(e.poi.adcode);
        this.placeSearch.search(e.poi.name); //关键字查询
      } else {
        this.$message.error('查询地址失败，请重新输入地址');
      }
    }
  }
};